/* Stylesheet */

.primary_button {
  height: 46px;
  text-transform: none;
  --background: var(--ion-gradient-primary);
  --color: var(--ion-color-text-secondary);
  --border-radius: 46px;
  --box-shadow: var(--ion-box-shadow);
  --background-hover-opacity: 0.0275;

  .icon {
    margin: 0px 12px 0px 0px;
    height: 21px;
    width: 21px;
  }

  .label {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
  }
}
